
export const userColumns = [
 
  {
    field: "name",
    headerName: "Name",
    width: 120,
  },
  {
    field: "ipdNo",
    headerName: "Ipd Number",
    width: 150,
  },
  {
    field: "billingMode",
    headerName: "Billing Mode",
    width: 130,
  },

  {
    field: "age",
    headerName: "Age",
    width: 100,
  },

  {
    field: "mobile",
    headerName: "Mobile",
    width: 150,
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 150,
  },
  {
    field: "dischargeStatus",
    headerName: "DischargeStatus",
    width: 180,
  },
  {
    field: "address",
    headerName: "Address",
    width: 380,
  },
  {
    field: "description",
    headerName: "Description",
    width: 380,
  },
];